import React from 'react'
import { Row } from 'antd'
import moment from 'moment'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomCol, CustomText, CustomDatePicker } from 'src/components'
import { projectFormStateSelector, setProjectFormItemValue } from 'src/features'

const ProjectCertificationCreditDates: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { is_active, kind } = useAppSelector(projectFormStateSelector)

  return (
    <Row>
      <CustomCol className='mr-2' lg={11}>
        <CustomText
          label={kind === 'carbon_forward' ? t('Forward.StartDate') : t('Projects.Fields.CreditStart')}
          type='secondary'
        />
        <CustomDatePicker
          name='credit_start'
          placeholder={t('Projects.Form.DatePlaceholder')}
          onChange={(date: moment.Moment) => {
            const value =  date ? moment(date).format('YYYY-MM-DD') : null
            dispatch(setProjectFormItemValue({ key: 'credit_start', value }))
          }}
          required={is_active}
        />
      </CustomCol>
      <CustomCol className='ml-2'>
        <CustomText
          label={kind === 'carbon_forward' ? t('Forward.EndDate') : t('Projects.Fields.CreditEnd')}
          type='secondary'
        />
        <CustomDatePicker
          name='credit_end'
          placeholder={t('Projects.Form.DatePlaceholder')}
          required={is_active}
          onChange={(date: moment.Moment) => {
            const value =  date ? moment(date).format('YYYY-MM-DD') : null
            dispatch(setProjectFormItemValue({ key: 'credit_end', value }))
          }}
          otherRules={[
            ({ getFieldValue }) => ({
              validator(_, creditEnd: moment.Moment) {
                const credit_start = getFieldValue('credit_start')
                if (!is_active) {
                  return Promise.resolve()
                }
                if (!credit_start) {
                  return Promise.reject(new Error(t('Projects.Form.CreditError')))
                }
                if (credit_start.isBefore(creditEnd)) {
                  return Promise.resolve()
                }
                if (credit_start) {
                  return Promise.reject(new Error(t('Projects.Form.CreditErrorTwo')))
                }
                return Promise.resolve()
              },
            })
          ]}
        />
      </CustomCol>
    </Row>
  )
}

export default ProjectCertificationCreditDates
